export interface ProfileOutcomeSet {
    id: number;
    strategyId: number;
    duration: string;
    exitCandidateId: number | null;
}

/** Preserve exact branch and objective lineage; multiple candidates need an explicit choice. */
export function selectDefaultProfileOutcomeSet(
    sets: readonly ProfileOutcomeSet[],
    strategyId: number | null,
    duration: string,
    primaryExitCandidateId: number | null
): ProfileOutcomeSet | null {
    const compatible = sets.filter(
        (set) =>
            set.strategyId === strategyId &&
            set.duration === duration &&
            (primaryExitCandidateId === null || set.exitCandidateId === primaryExitCandidateId)
    );
    return compatible.length === 1 ? compatible[0] : null;
}

/** A configured choice or a single available horizon is safe; array order is not research intent. */
export function selectProfileHorizon(horizons: readonly number[], requested: number | null): number | null {
    if (requested !== null && horizons.includes(requested)) return requested;
    return horizons.length === 1 ? horizons[0] : null;
}
